import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { combineLatest, of, Subscription } from 'rxjs';
import { AanAfwezigheid } from 'src/app/afas-classes/aanafwezigheid.class';
import { Realisation } from 'src/app/classes/realisation';
import { CodaltComponent } from 'src/app/codalt.component';
import { AfasService } from 'src/app/services/afas.service';
import { RealisationService } from 'src/app/services/realisation.service';
import { Utils } from 'src/app/utils.class';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'app-week-schedule',
    templateUrl: './week-schedule.component.html',
    styleUrls: ['./week-schedule.component.scss'],
    standalone: false,
})
export class WeekScheduleComponent extends CodaltComponent implements OnInit {
    maxDate: Date;

    beginDate: Date;
    endDate: Date;
    realisations?: Realisation[];
    aanAfwezigheid?: AanAfwezigheid[];

    private scheduleDataSubscription?: Subscription;

    constructor(
        private activatedRoute: ActivatedRoute,
        private afasService: AfasService,
        private router: Router,
        private realisationService: RealisationService
    ) {
        super();
        this.maxDate = this.realisationService.calcMaxDate();
    }

    ngOnInit() {
        this.subscriptions.add(
            this.activatedRoute.params.subscribe(params => {
                const currentDate = new Date();
                const year = +(params.year ?? Utils.formatDate(currentDate, 'Y'));
                const week = +(params.week ?? Utils.formatDate(currentDate, 'w'));

                const monday = new Date(year, 0, 4);
                Utils.setTime(monday, 0, 0);
                monday.setDate(monday.getDate() - ((monday.getDay() + 6) % 7) + 7 * (week - 1));

                const sunday = new Date(monday);
                sunday.setDate(sunday.getDate() + 6);

                this.beginDate = monday;
                this.endDate = sunday;
                this.loadScheduleData();
            })
        );
        window.onfocus = () => this.loadScheduleData();
    }

    moveWeek(days: number) {
        const date = new Date(this.beginDate);
        date.setDate(date.getDate() + days);
        this.router.navigate(['weekschedule', Utils.getWeekNumber(date), Utils.formatDate(date, 'Y')]);
    }

    private loadScheduleData() {
        this.scheduleDataSubscription?.unsubscribe();
        this.realisations = undefined;
        this.aanAfwezigheid = undefined;

        const afas$ = environment.disableAfas
            ? of({ data: [] as AanAfwezigheid[] })
            : this.afasService.getOwnAanAfwezigheid(this.beginDate, this.endDate);

        this.scheduleDataSubscription = combineLatest([
            afas$,
            this.realisationService.getUserSchedule(this.beginDate, this.endDate),
        ]).subscribe(([aanAfwezigheid, realisations]) => {
            this.aanAfwezigheid = aanAfwezigheid.data;
            this.realisations = realisations.data;
        });
        this.subscriptions.add(this.scheduleDataSubscription);
    }
}
